var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-fede';
                    var viewUrl = 'sprite.svg#view-icon-fede';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 381 382',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };